"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const routeUrls_1 = require("root/src/shared/descriptions/routes/routeUrls");
const drops_constants_1 = require("root/src/client/v2/_pages/drops/fixtures/drops.constants");
function getLogoutUrl() {
    const dropsUrl = routeUrls_1.routeUrls.drops({
        tab: drops_constants_1.DROPS_DEFAULT_TAB,
    });
    return `${dropsUrl}&logout=true`;
}
exports.default = getLogoutUrl;
